import React from 'react';
import cx from 'classnames';
// components
import Menu from '@/components/Menu';
// widgets
import Content from './widgets/Content';
// helpers
import { transformOptions } from './helpers';
// styles
import styles from './SelectBox.module.scss';
const defaultProps = {
    disabled: [],
};
class SelectBoxNext extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.menuApiRef = React.createRef();
        this.state = this.getInitialState();
        this.onClick = () => {
            if (this.menuApiRef.current) {
                this.menuApiRef.current.isOpen
                    ? this.menuApiRef.current.close()
                    : this.menuApiRef.current.open();
            }
        };
        this.closeMenu = () => {
            if (this.menuApiRef.current) {
                this.menuApiRef.current.close();
            }
        };
        this.updateSelectedOptions = (updatedOptions) => {
            this.setState({ internalOptions: updatedOptions });
        };
    }
    componentDidUpdate(prevProps) {
        /**
         * If the options prop changes, we need to update the internalOptions
         */
        if (prevProps.options !== this.props.options ||
            prevProps.options.length !== this.props.options.length) {
            const internalOptions = transformOptions({
                options: this.props.options,
                value: this.props.value,
                disabledValues: this.props.disabled,
                identifier: this.props.identifier,
            });
            this.setState({ internalOptions });
        }
        /**
         * If the value prop changes, we need to update the internalOptions
         */
        if (prevProps.value !== this.props.value) {
            const internalOptions = transformOptions({
                options: this.props.options,
                value: this.props.value,
                disabledValues: this.props.disabled,
                identifier: this.props.identifier,
            });
            this.setState({ internalOptions });
        }
    }
    getInitialState() {
        return {
            internalOptions: transformOptions({
                options: this.props.options,
                value: this.props.value,
                disabledValues: this.props.disabled,
                identifier: this.props.identifier,
            }),
        };
    }
    render() {
        return (React.createElement(Menu, { Content: Content, placement: "bottom-start", className: this.props.className, contentProps: {
                options: this.state.internalOptions,
                renderFunction: this.props.renderFunction,
                updateOptions: this.updateSelectedOptions,
                closeMenu: this.closeMenu,
                onChange: this.props.onChange,
                className: this.props.contentClassName,
            }, ref: this.menuApiRef, autoUpdatePosition: this.props.autoUpdatePosition },
            React.createElement("button", { onClick: this.onClick, className: cx(styles.trigger, this.props.actionClassName) }, this.props.children)));
    }
}
SelectBoxNext.defaultProps = defaultProps;
export default SelectBoxNext;
